function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import { Tooltip, Checkbox, Button, Switch } from "@blueprintjs/core";
export var withCommand = function withCommand(mappings) {
  return function (WrappedComponent) {
    return function (_ref) {
      var cmd = _ref.cmd,
          _ref$cmdOptions = _ref.cmdOptions,
          cmdOptions = _ref$cmdOptions === void 0 ? {} : _ref$cmdOptions,
          props = _objectWithoutPropertiesLoose(_ref, ["cmd", "cmdOptions"]);

      var mappedProps = {};
      Object.keys(mappings).forEach(function (k) {
        mappedProps[k] = mappings[k] === "execute" ? function (event) {
          return cmd.execute({
            event: event
          });
        } : typeof mappings[k] === "function" ? mappings[k](cmd, props) : cmd[mappings[k]];
      });
      var out = /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, mappedProps));
      var tooltip = cmd.tooltip || typeof cmd.isDisabled === "string" && cmd.isDisabled;

      if (tooltip && !cmdOptions.ignoreTooltip) {
        out = /*#__PURE__*/React.createElement(Tooltip, {
          content: tooltip
        }, out);
      }

      return cmd.isHidden && !cmdOptions.ignoreHidden ? null : out;
    };
  };
};
export var CmdCheckbox = withCommand({
  onChange: "execute",
  label: function label(cmd, props) {
    return props.name || props.prefix && /*#__PURE__*/React.createElement(React.Fragment, null, props.prefix, cmd.name) || cmd.name;
  },
  disabled: "isDisabled",
  checked: "isActive"
})(Checkbox);
export var CmdSwitch = withCommand({
  onChange: "execute",
  label: function label(cmd, props) {
    return props.name || props.prefix && /*#__PURE__*/React.createElement(React.Fragment, null, props.prefix, cmd.name) || cmd.name;
  },
  disabled: "isDisabled",
  checked: "isActive"
})(Switch);

var Div = function Div(_ref2) {
  var onChange = _ref2.onChange,
      children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onChange
  }, children);
};

export var CmdDiv = withCommand({
  onChange: "execute",
  children: function children(cmd, props) {
    return props.name || props.prefix && /*#__PURE__*/React.createElement(React.Fragment, null, props.prefix, cmd.name) || cmd.name;
  },
  disabled: "isDisabled",
  checked: "isActive"
})(Div);
export var CmdButton = withCommand({
  onClick: "execute",
  text: function text(cmd) {
    return cmd.isActive === false && cmd.inactiveName || cmd.name;
  },
  icon: "icon",
  disabled: "isDisabled"
})(Button);